// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3XQRQ","col":"styles_col__3wR0y","fulfillmentStatus":"styles_fulfillmentStatus__pZcFs","emailCol":"styles_emailCol__14FsK"};